export default __webpack_public_path__ + "static/media/reserved.74c61446.png";